import type { InputNumberProps } from "./input-number.type";

import { InputNumber as AntDesignInputNumber, Space } from "antd";

/**
 * Uses Ant Design `InputNumber` component in background. It just
 * replaces Ant Design deprecated props `addonBefore` and `addonAfter`.
 */
export const InputNumber = ({
  addonBefore,
  addonAfter,
  ...inputProps
}: InputNumberProps) => {
  if (!addonBefore && !addonAfter) {
    return <AntDesignInputNumber {...inputProps} />;
  }

  return (
    <Space.Compact block>
      {addonBefore ? <Space.Addon>{addonBefore}</Space.Addon> : null}
      <AntDesignInputNumber {...inputProps} />
      {addonAfter ? <Space.Addon>{addonAfter}</Space.Addon> : null}
    </Space.Compact>
  );
};
